import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import * as signalR from '@microsoft/signalr';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { DataProviderService } from './data-provider.service';
import jwtDecode from 'jwt-decode';
import { OperationState } from '../../model/thing.model';

//const signalR = require('@microsoft/signalr');

@Injectable({
    providedIn: 'root'
})
export class EventService
{

    private readonly _http: HttpClient;
    // private readonly _baseUrl: string = 'http://localhost:7071/api';
    private readonly _baseUrl: string = environment.apiUrl + environment.apiVersion;
    private hubConnection: HubConnection;
    messages: Subject<string> = new Subject();
    public ControlLightEvent = new Subject();

    constructor(http: HttpClient, private auth: AuthenticationService, private data: DataProviderService)
    {
        this._http = http;
    }

    private getConnectionInfo(header): Observable<SignalRConnectionInfo>
    {
        const requestUrl = `${this._baseUrl}/negotiate`;
        const tokenNoBearer = header.get('authorization').replace('Bearer ', '');
        let newHeader = header.set('authorization', tokenNoBearer);

        // For local debugging, in live it will be overwritten by a Microsoft Service
        const decoToken = jwtDecode(tokenNoBearer) as any;
        newHeader = newHeader.set('x-ms-client-principal-id', decoToken['oid']);

        return this._http.get<SignalRConnectionInfo>(requestUrl, {headers: newHeader});
    }

    init(header)
    {
        this.getConnectionInfo(header).subscribe((info) =>
        {


            const options = {
                accessTokenFactory: () => info.accessToken,
            };

            this.hubConnection = new signalR.HubConnectionBuilder()
                .withUrl(info.url, options)
                .configureLogging(signalR.LogLevel.Information)
                .build();

            this.hubConnection.start()
                .then(() =>
                {
                    console.log('connected to event service');
                    setInterval(() => {
                        this.reconnect();
                    }, 5000)
                })
                .catch((err) =>
                {
                    console.error(err.toString());
                });

            this.hubConnection.on('notify', (data: any) =>
            {
                console.log('notifyEvent thrown');
                console.log(data);
            });

            this.hubConnection.on('deviceEvent', (data: any) =>
            {
                console.log('deviceEvent thrown');
                console.log(data);
                //const thing = this.data.things.find(x => x.id === data.id );
                //thing.status = data.status;
            });


            this.hubConnection.on('controllight', (message: any) =>
            {
                if (message.propertySet !== "CONTROL_LIGHT") return;

                let thing = this.data.getThing(message.thingId);
                if (thing != null && thing.controlCabinet?.id != null)
                {
                    // Thing mit Schaltschrank liefert eigene Lampen-Events
                    thing.hasOwnControlLight = true;
                }
                if (thing == null) {
                   thing = this.data.things.find(x => x.controlCabinet?.id === message.thingId)?.controlCabinet;
                }

                if (thing == null) return;

                thing.lightStates = Object.assign(thing.lightStates, message.measures);

                if (thing.lightStates['RED'] === true)
                {
                    thing.status = OperationState.STOP;
                }
                else if (thing.lightStates['ORANGE'] === true)
                {
                    thing.status = OperationState.ORANGESTATE;
                }
                else if (thing.lightStates['BLUE'] === true)
                {
                    thing.status = OperationState.HAND;
                }
                else if (thing.lightStates['GREEN'] === true)
                {
                    thing.status = OperationState.AUTOMATIC;
                }
                else if (thing.lightStates['WHITE'] === true)
                {
                    thing.status = OperationState.UNDEFINED;
                }
                else
                {
                    thing.status = OperationState.UNDEFINED;
                }

                // this.ControlLightEvent.next(message);
            });

        });
    }

    reconnect()
    {
        if (this.hubConnection.state !== HubConnectionState.Connected)
        {
            this.hubConnection.start()
                .then(() =>
                {
                    console.log('reconnected to event service');
                })
                .catch((err) =>
                {
                    console.error(err.toString());
                });
        }
    }

    send(message: string): Observable<void>
    {
        const requestUrl = `${this._baseUrl}/messages`;
        return this._http.post(requestUrl, message).pipe(map((result: any) =>
        {
        }));
    }

    receieve(message: Message): Message[]
    {
        // read in from local strorage
        const messages = this.load();
        messages.unshift(message);
        localStorage.setItem('messages', JSON.stringify(messages));
        return messages;
    }

    load(): Message[]
    {
        const messagesLocal = localStorage.getItem('messages');
        let messagesResponse = [];
        if (messagesLocal !== null)
        {
            messagesResponse = JSON.parse(messagesLocal);
        }
        return messagesResponse;
    }

    clear(): Observable<void>
    {
        const messagesLocal = localStorage.getItem('messages');
        const messagesResponse = [];
        if (messagesLocal !== null)
        {
            localStorage.setItem('messages', JSON.stringify(messagesResponse));
        }
        return of(null);
    }

}

class SignalRConnectionInfo
{
    endpoint: string;
    accessToken: string;
    url: string;
}

class Message
{
    sender: string;
    body: string;
}
